import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import ButtonStrap from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';

var firebase = require('firebase/app');
// Add the Firebase products that you want to use
require('firebase/auth');
require('firebase/firestore');

export class SignUpPage extends Component {
  constructor(props) {
    super(props);

    this.openTermsAndConditions = this.openTermsAndConditions.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.showPasswordAlert = this.showPasswordAlert.bind(this);

    this.state = {
      showTerms: false,
      accType: 'User',
      accEmail: '',
      accName: '',
      accPass: '',
      accPassRepeat: '',
      termsAgree: false,
      showAlert: false, // for handling alerts
      alertText: [],
    };
  }

  handleFormSubmit(e) {
    e.preventDefault();

    let alertNeeded = false,
      alerts = [];

    if (this.state.accPassRepeat !== this.state.accPass) {
      alertNeeded = true;
      alerts = alerts.concat('Please ensure the passwords match.');
    }

    if (this.state.accPass.length <= 5) {
      alertNeeded = true;
      alerts = alerts.concat('The password must be 6 characters or more.');
    }

    if (!this.state.termsAgree) {
      alertNeeded = true;
      alerts = alerts.concat(
        'The terms of conditions must be accepted. This is to ensure a safe and friendly environment for all users and developers alike.'
      );
    }

    // Check if email exists

    // Need to escape the scope of this as in the function it is not accesbile
    var _this = this;

    const db = firebase.firestore();
    const displayNamesRef = db.collection('displayNames');

    // Check if display name exists
    displayNamesRef
      .where('displayName', '==', this.state.accName)
      .get()
      .then(queryResult => {
        queryResult.forEach(function (doc) {
          if (doc.data() !== undefined) {
            alertNeeded = true;
            alerts = alerts.concat(
              'The display name has already been taken. Please pick another one.'
            );
            _this.setState({ showAlert: true, alertText: alerts });
          } else {
          }
        });
        // The display name IS available
        if (alertNeeded) {
          _this.setState({ showAlert: true, alertText: alerts });
        } else {
          // All validations passed, can proced with account creation
          firebase
            .auth()
            .createUserWithEmailAndPassword(
              _this.state.accEmail,
              _this.state.accPass
            )
            .then(_authResult => {
              displayNamesRef
                .doc(_authResult.user.uid)
                .set({
                  displayName: _this.state.accName,
                })
                .then(result => {
                  let accCreateType = this.state.accType.toLowerCase();
                  var userData = {
                    accType: accCreateType,
                    displayName: _this.state.accName,
                    email: _this.state.accEmail,
                    softies: 0,
                    pagesLeft: 2,
                    dateCreated: firebase.firestore.Timestamp.fromDate(
                      new Date()
                    ),
                    reviews: [],
                    qas: [],
                    pages: [],
                    userMessage: '',
                  };
                  db.collection('user_accounts')
                    .doc(_this.state.accEmail)
                    .set(userData)
                    .then(function (result) {
                      _authResult.user
                        .updateProfile({
                          displayName: _this.state.accName,
                          photoURL: accCreateType, // Store accType in photo URL
                        })
                        .then(() => {
                          // All steps passed, redirect to last page
                          _this.props.history.push('/my_account');
                          _this.props.loginUser(
                            accCreateType,
                            _authResult.user.displayName
                          );
                        });
                    });
                });
            })
            .catch(error => {
              // Handle Errors here.
              var errorMessage = error.message;
              // ...
              alertNeeded = true;
              alerts = alerts.concat(errorMessage);
              _this.setState({ showAlert: true, alertText: alerts });
            });
        }
      });
  }

  showPasswordAlert() {
    if (this.state.showAlert) {
      return (
        <Alert variant="danger">
          <Alert.Heading> Please fix the following problems: </Alert.Heading>
          <ul>
            {this.state.alertText.map(alertText => (
              <li> {alertText} </li>
            ))}
          </ul>
        </Alert>
      );
    } else {
      return <div></div>;
    }
  }

  openTermsAndConditions() {
    this.setState({
      showTerms: !this.state.showTerms,
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  handleToggle(e) {
    console.log('What');
    this.setState({ termsAgree: !this.state.termsAgree });
  }

  render() {
    return !this.props.isAuthenticated ?
      <div className="container">
        <h3> Create an account - it's easy! </h3>
        <this.showPasswordAlert />

        <Form onSubmit={this.handleFormSubmit}>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Label>Account type</Form.Label>
            <Form.Control
              as="select"
              name="accType"
              onChange={this.handleChange}
            >
              <option>User</option>
              <option>Developer</option>
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formBasicName">
            <Form.Label>Display name</Form.Label>
            <Form.Control
              type="name"
              maxLength="20"
              name="accName"
              onChange={this.handleChange}
              placeholder="Enter display name"
            />
          </Form.Group>

          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              name="accEmail"
              maxLength="40"
              onChange={this.handleChange}
              placeholder="name@example.com"
            />
            <Form.Text className="text-muted">
              We truly care about your privacy. You're email will purely be used
              for login and will not be shared with anyone else.
            </Form.Text>
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              maxLength="25"
              name="accPass"
              onChange={this.handleChange}
              placeholder="Password"
            />
          </Form.Group>

          <Form.Group controlId="formBasicPasswordRepeat">
            <Form.Label>Re-enter password</Form.Label>
            <Form.Control
              type="password"
              maxLength="25"
              name="accPassRepeat"
              onChange={this.handleChange}
              placeholder="Re-enter password"
            />
          </Form.Group>

          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              required
              type="checkbox"
              onChange={this.handleToggle}
              label="I agree to the fair play policy*"
            />
          </Form.Group>
          <ButtonStrap variant="primary" type="submit">
            Create my account
          </ButtonStrap>
        </Form>

        <p>
          <button onClick={this.openTermsAndConditions} style={buttonLinkStyle}>
            *Fair play policy
          </button>
        </p>

        <Modal show={this.state.showTerms} onHide={this.openTermsAndConditions}>
          <Modal.Header closeButton>
            <Modal.Title>Terms and Conditions </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            We aren't fans of those sketchy long terms pages either.
            <br /> <br />
            <p>
              By creating your account, you pledge to be an honest member of the
              indie-dev community. If you do not follow the righteous path and
              commit inappropriate actions, your account may be suspended or
              banned.
            </p>
            <br />

            <p>
              That's all we expect from you :)
            </p>
          </Modal.Body>
          <Modal.Footer>
            <ButtonStrap
              variant="secondary"
              onClick={this.openTermsAndConditions}
            >
              Close
            </ButtonStrap>
          </Modal.Footer>
        </Modal>
      </div>
    :
      <div className="container">
          <Alert variant="danger"> You are already logged in! </Alert>
      </div>
  }
}

const buttonLinkStyle = {
  background: 'none!important',
  'background-color': 'rgba(0,0,0,0)',
  border: 'none',
  padding: '0!important',
  'font-family': 'arial, sans-serif',
  color: '#069',
  cursor: 'pointer',
  margin: '0px 0px 30px 0px',
};

export default SignUpPage;
